// extracted by mini-css-extract-plugin
export default {"messageType":"index_messageType__6p6zC"};